export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/procedure-list`,
        name: `${prefix}.procedure-list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.procedure-list.index`,
                PageDescription: "Theatre: Procedure List",
            },
        },
    }, {
        path: `/${prefix}/procedure-list2`,
        name: `${prefix}.procedure-list2.index`,
        component: () => import('./Index2.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.procedure-list2.index`,
                PageDescription: "Theatre: Procedure List 2",
            },
        },
    },
     
];
